var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mining"},[_c('p',[_vm._v("Mining")]),_c('p',{staticClass:"btn",on:{"click":_vm.check}},[_vm._v("check counts")])])}
var staticRenderFns = []

export { render, staticRenderFns }